import React, { Fragment } from "react";
import "./BrowseGrid.css";
import "./BrowseCard.scss";
import useToast from "../hooks/useToast";
import { fetchFeaturedCauses } from "../services/causes.service";

function FeaturedCauses({
  search,
  featuredCauses,
  setFeaturedCauses,
  fundCategoryId,
}) {
  const notifyFetchFeaturedCausesError = useToast({
    type: "error",
    id: `featuredCauses${fundCategoryId}`,
    actionText: "RETRY?",
    action: async () => await getFeaturedCauses(),
    dismissable: true,
    message: `There was a problem loading featured causes for category ${fundCategoryId}.`,
  });

  function getFeaturedCauses() {
    return fetchFeaturedCauses(fundCategoryId)
      .then((response) => {
        setFeaturedCauses(response);
        return response;
      })
      .catch(() => {
        notifyFetchFeaturedCausesError();
      });
  }

  React.useEffect(() => {
    getFeaturedCauses();
  }, [fundCategoryId]);

  const renderFeaturedCauses = () =>
    featuredCauses.map((cause) => {
      const s = cause.field_featured_image;
      let rex = /<img[^>]+src="([^">]+)/g;
      let r = rex.exec(s);
      const featuredImage = r !== null ? r[1] : null;
      return (
        <div
          className="browse__grid-item browse__grid-item--featured-cause"
          key={cause.uuid}
        >
          <div className="browse-card browse-card--featured-cause">
            <div className="browse-card__inner browse-card__inner--featured-cause">
              <div className="browse-card__image browse-card__image--featured-cause">
                <img src={featuredImage} />
              </div>
              <div className="browse-card__description browse-card__description--featured-cause">
                <h3
                  className="browse-card__title browse-card__title--featured-cause"
                  // This is safe because Drupal encodes HTML entities in title
                  // string for us.
                  dangerouslySetInnerHTML={{ __html: cause.title }}
                />
                <div className="browse-card__actions browse-card__action--featured-cause">
                  <a
                    className="browse-card__button browse-card__button--featured-cause coh-style-link-button-with-icon"
                    href={cause.link}
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

  return (
    <>
      {typeof search === "undefined" && featuredCauses.length > 0 ? (
        <div className="browse__wrapper browse__wrapper--featured-causes">
          <div>
            <h2 className="browse__title browse__title--featured-causes">
              Featured Causes
            </h2>
            <div className="browse__grid browse__grid--featured-causes">
              {renderFeaturedCauses()}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default FeaturedCauses;
